import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import * as React from 'react';
import _isArray from 'lodash/isArray';
import _isNumber from 'lodash/isNumber';
import { ConfigContext } from '../ConfigProvider';
/**
 * 汉字和全角标点的正则
 */

var HAN_REGEX = /([\u4E00-\u9FA5]|[\uFE30-\uFFA0])/;
/**
 * input内容的长度
 * @param value
 * @param chineseAsTwoChars
 */

export var getInputValueLength = function getInputValueLength(value, chineseAsTwoChars) {
  var valueType = _typeof(value);

  if (!_isArray(value) && valueType !== 'string' && valueType !== 'number') {
    return 0;
  }

  var stringValue = String(value);

  if (chineseAsTwoChars) {
    var length = 0;

    for (var i = 0; i < stringValue.length; i++) {
      if (HAN_REGEX.test(stringValue.charAt(i))) {
        length += 2;
      } else {
        length += 1;
      }
    } // return Math.ceil(length / 2);


    return length;
  }

  return stringValue.length;
};
/**
 * 如果中文字符占两个字符长度，需要特殊处理
 * @param e
 * @param inputTarget
 * @param maxLength
 */

export function resetValueWhenUseChinese(e, inputTarget, maxLength) {
  if (_isNumber(maxLength) && maxLength) {
    var event = Object.create(e);
    var target = event.target;
    var value = target.value;

    if (typeof value === 'string') {
      var valueLength = value.length;

      if (valueLength > maxLength / 2) {
        var i = 0;
        var lastIndex = 0;
        var length = 0;

        for (; i < valueLength && length < maxLength; i++) {
          length = HAN_REGEX.test(value.charAt(i)) ? length + 2 : length + 1;
        }

        if (length >= maxLength) {
          lastIndex = length > maxLength ? i - 1 : i;
          var sliceValue = value.slice(0, lastIndex);
          target.value = sliceValue;

          if (inputTarget) {
            inputTarget.value = sliceValue;
          }
        }
      }
    }

    return event;
  }

  return e;
}

var InputCount = function InputCount(props) {
  var _getPrettyCls;

  var _React$useContext = React.useContext(ConfigContext),
      getPrettyCls = _React$useContext.getPrettyCls;

  var chineseAsTwoChars = props.chineseAsTwoChars,
      maxLength = props.maxLength,
      prefixCls = props.prefixCls,
      value = props.value,
      type = props.type,
      _props$position = props.position,
      position = _props$position === void 0 ? 'middle' : _props$position;
  var maxLengthText = _isNumber(maxLength) ? "/".concat(maxLength) : '';

  var _React$useState = React.useState(type),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      countType = _React$useState2[0],
      setCountType = _React$useState2[1];

  React.useEffect(function () {
    if (value && maxLength && getInputValueLength(value, chineseAsTwoChars) >= maxLength) {
      setCountType('warning');
    } else {
      setCountType('default');
    }
  }, [value, maxLength, chineseAsTwoChars]);
  return /*#__PURE__*/React.createElement("span", {
    className: getPrettyCls('input-count', prefixCls)((_getPrettyCls = {}, _defineProperty(_getPrettyCls, countType, true), _defineProperty(_getPrettyCls, "position", position), _getPrettyCls))
  }, "".concat(getInputValueLength(value, chineseAsTwoChars)).concat(maxLengthText));
};

export default InputCount;